module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar field = model.fields[formMapping.modelFieldIndex];\nvar fieldConfig = field.config || {};\nvar translationKey = false;\nvar langCode = (((storage || {}).user || {}).data || {}).langCode || 'de-at';\nvar value = '-';\nvar additionalStyle = '';\nvar additionalStyles = [];\nvar fieldPath = false\nif(field.atom){\nif(fieldConfig.tagBubbleList){\nif(resourceData.value && field.atom.dataType === 'tag-picker') {\nvar e, entity, categoryID, categoryDataID;\nvar o, option, categoryNameFound = false;\nvar c, child;\nvar bubbles = {}\nfor(e in resourceData.value){\nentity = String(resourceData.value[e] || '').split('_') || []\ncategoryID = entity[0] || 0\ncategoryDataID = entity[1] || 0\nif(categoryID && categoryDataID){\nfor(o in (field['tag-picker-data'] || {}).options || []){\nif((option = field['tag-picker-data'].options[o]).id == categoryID){\nfor(c in option.children || []){\nif((child = option.children[c] || {}).id == categoryDataID){\nbubbles[categoryID] = bubbles[categoryID] || { name: option.name, children: {}}\nbubbles[categoryID].children[categoryDataID] = child.name\nbreak;\n}\n}\nbreak;\n}\n}\n}\n}\nvar bubblesHtml = ''\nfor(categoryID in bubbles){\nbubblesHtml += `<div class=\"bubbles\"><div class=\"bubbleParent\">${bubbles[categoryID].name}:</div>`\nfor(categoryDataID in bubbles[categoryID].children){\nbubblesHtml += `<div class=\"bubble\" data-tag-key=\"${categoryID}_${categoryDataID}\">${bubbles[categoryID].children[categoryDataID]}</div>`\n}\nbubblesHtml += `</div>`\n}\nif(bubblesHtml){\nvar additionalBubbleContainerStyles = ['bubbleContainer']\nif(fieldConfig.tagBubbleList.additionalStyles){\nif(Array.isArray(fieldConfig.tagBubbleList.additionalStyles)){\nadditionalBubbleContainerStyles = additionalBubbleContainerStyles.concat(fieldConfig.tagBubbleList.additionalStyles)\n} else {\nadditionalBubbleContainerStyles.push(String(fieldConfig.tagBubbleList.additionalStyles))\n}\n}\nvalue = `<div class=\"${additionalBubbleContainerStyles.join(' ')}\">${bubblesHtml}</div>`\n}\n}\n} else if(model.singleValue){\nif(resourceData.value && fieldConfig.fieldPath) {\nfieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\\//, '').replace(/\\/$/, '');\n}\nelse if(field.atom.dataType === 'boolean'){\ntranslationKey = 'dataValues.' + field.atom.dataType + '.' + resourceData.value;\n}\nelse if(resourceData.value && field.atom.dataType === 'category-picker') {\nvar o, option, categoryNameFound = false;\nfor(o in (field['category-picker-data'] || {}).options || []){\nif((option = field['category-picker-data'].options[o]).value === resourceData.value){\nif(option.color)                             additionalStyles.push('background-color: ' + option.color);\nif((option.config || {}).complementaryColor) additionalStyles.push('color: ' + option.config.complementaryColor);\nif(((option.lang || {})[langCode] || {}).name){\nvalue = option.lang[langCode].name;\ncategoryNameFound = true;\n}\nbreak;\n}\n}\nif(!categoryNameFound) value = '-';\n}\nelse if(resourceData.value && field.atom.dataType === 'datetime') {\nvalue = utils.moment(resourceData.value).format((field.config || {}).momentDateFormat || 'dd.mm.yyyy');\n}\nelse if(resourceData.value && field.atom.dataType === 'json'){\nvalue = JSON.stringify(resourceData.value);\n}\nelse if(field.atom.dataType === 'text' || field.atom.dataType === 'integer' || field.atom.dataType === 'float') {\nif(!resourceData.value || resourceData.value === null || (typeof(resourceData.value) === 'object' && Object.keys(resourceData.value) <= 0)) {\nvalue = '-';\n} else if(field.atom.dataType === 'integer' || field.atom.dataType === 'float'){\nvalue = utils.number.format(resourceData.value, fieldConfig.currencyFormat || fieldConfig.format || {}, field.atom.dataType).formatted\n} else {\nvalue = resourceData.value;\n}\n}\n} else if(field.atom.dataType === 'custom'){\nif((field.config || {}).tagBubbleList && resourceData){\nvar categories = (((resourceData || {}).children || {}).cms_entities_categories || {}).data || []\nvar bubbles = [], showIDs, categoryData, tag, c, tagKey, categoryEntityAttributes;\nif(categories.length > 0){\nshowIDs = false;\nif(storage.user){\nshowIDs = storage.user.hasRoleOption('showIDs', 'art_crm');\n}\nfor(c in categories){\ncategoryEntityAttributes = categories[c].attributes || {}\ncategoryData = ((categories[c].children || {}).cms_categoriesData || {}).data || {};\ntag = (((categoryData.attributes || {}).trls || {})[langCode] || {}).name || 'UNKNOWN_TAG'\ntagKey = ''\nif(categoryEntityAttributes.categoryID && categoryEntityAttributes.categoryDataID){\ntagKey = `${categoryEntityAttributes.categoryID}_${categoryEntityAttributes.categoryDataID}`\n}\nif(showIDs){\ntag = '[' + (categoryData.attributes || {})[categoryData.primaryKey || 'categoryDataID'] + '] ' + tag\n}\nbubbles.push('<div class=\"bubble\" data-tag-key=\"' + tagKey + '\">' + tag + '</div>');\n}\nvalue = '<div class=\"bubbles\">' + (bubbles.join('') || '') + '</div>';\n} else {\nvalue = ''\n}\n} else if (fieldConfig.fieldPath){\nfieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\\//, '').replace(/\\/$/, '');\n} else {\nvalue = '-';\n}\n} else {\nvalue = '-';\n}\n}\nvar colClass = (field.config || {}).colClass;\nvar isEllipsis = colClass === 'ellipsis'\nvar additionalClasses = [];\nif(fieldConfig.minWidth){\nadditionalStyles.push('min-width: ' + fieldConfig.minWidth);\n}\nif(fieldConfig.width){\nadditionalStyles.push('width: ' + fieldConfig.width);\n}\nif(fieldConfig.maxWidth){\nadditionalStyles.push('max-width: ' + fieldConfig.maxWidth);\n}\nif(additionalStyles.length > 0){\nadditionalStyle = ' style=\"' + additionalStyles.join(';') + '\"';\n}\nif(field.fieldCode) additionalClasses.push('fieldOf_' + field.fieldCode);\nif(colClass) additionalClasses.push(colClass);\nvar colSpan = 1;\nvar rowSpan = 1;\nif(fieldConfig.colSpan) colSpan = fieldConfig.colSpan;\nif(fieldConfig.rowSpan) rowSpan = fieldConfig.rowSpan;\nif(fieldConfig.textAlign === 'right')       additionalClasses.push('textAlignRight')\nelse if(fieldConfig.textAlign === 'center') additionalClasses.push('textAlignCenter')\n%>\n<td colspan=\"<%= colSpan %>\" rowspan=\"<%= rowSpan %>\" data-model-field-index=\"<%= formMapping.modelFieldIndex %>\" class=\"<%= additionalClasses.join(' '); %>\" title=\"<%= (isEllipsis ? value : '') %>\"<%- additionalStyle %>>\n<%\nif (fieldPath) {\n%><%- include(fieldPath, { model: field, config: fieldConfig.componentConfig || {}, resourceData: resourceData }); %><%\n} else {\n%><%- translationKey ? __(translationKey) : value %><%\n}\n%>\n</td>"
  , __filename = "node_modules/frontend-controller/baseComponents/tableSimple/col.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var field = model.fields[formMapping.modelFieldIndex];
var fieldConfig = field.config || {};
var translationKey = false;
var langCode = (((storage || {}).user || {}).data || {}).langCode || 'de-at';
var value = '-';
var additionalStyle = '';
var additionalStyles = [];
var fieldPath = false
if(field.atom){
if(fieldConfig.tagBubbleList){
if(resourceData.value && field.atom.dataType === 'tag-picker') {
var e, entity, categoryID, categoryDataID;
var o, option, categoryNameFound = false;
var c, child;
var bubbles = {}
for(e in resourceData.value){
entity = String(resourceData.value[e] || '').split('_') || []
categoryID = entity[0] || 0
categoryDataID = entity[1] || 0
if(categoryID && categoryDataID){
for(o in (field['tag-picker-data'] || {}).options || []){
if((option = field['tag-picker-data'].options[o]).id == categoryID){
for(c in option.children || []){
if((child = option.children[c] || {}).id == categoryDataID){
bubbles[categoryID] = bubbles[categoryID] || { name: option.name, children: {}}
bubbles[categoryID].children[categoryDataID] = child.name
break;
}
}
break;
}
}
}
}
var bubblesHtml = ''
for(categoryID in bubbles){
bubblesHtml += `<div class="bubbles"><div class="bubbleParent">${bubbles[categoryID].name}:</div>`
for(categoryDataID in bubbles[categoryID].children){
bubblesHtml += `<div class="bubble" data-tag-key="${categoryID}_${categoryDataID}">${bubbles[categoryID].children[categoryDataID]}</div>`
}
bubblesHtml += `</div>`
}
if(bubblesHtml){
var additionalBubbleContainerStyles = ['bubbleContainer']
if(fieldConfig.tagBubbleList.additionalStyles){
if(Array.isArray(fieldConfig.tagBubbleList.additionalStyles)){
additionalBubbleContainerStyles = additionalBubbleContainerStyles.concat(fieldConfig.tagBubbleList.additionalStyles)
} else {
additionalBubbleContainerStyles.push(String(fieldConfig.tagBubbleList.additionalStyles))
}
}
value = `<div class="${additionalBubbleContainerStyles.join(' ')}">${bubblesHtml}</div>`
}
}
} else if(model.singleValue){
if(resourceData.value && fieldConfig.fieldPath) {
fieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\//, '').replace(/\/$/, '');
}
else if(field.atom.dataType === 'boolean'){
translationKey = 'dataValues.' + field.atom.dataType + '.' + resourceData.value;
}
else if(resourceData.value && field.atom.dataType === 'category-picker') {
var o, option, categoryNameFound = false;
for(o in (field['category-picker-data'] || {}).options || []){
if((option = field['category-picker-data'].options[o]).value === resourceData.value){
if(option.color)                             additionalStyles.push('background-color: ' + option.color);
if((option.config || {}).complementaryColor) additionalStyles.push('color: ' + option.config.complementaryColor);
if(((option.lang || {})[langCode] || {}).name){
value = option.lang[langCode].name;
categoryNameFound = true;
}
break;
}
}
if(!categoryNameFound) value = '-';
}
else if(resourceData.value && field.atom.dataType === 'datetime') {
value = utils.moment(resourceData.value).format((field.config || {}).momentDateFormat || 'dd.mm.yyyy');
}
else if(resourceData.value && field.atom.dataType === 'json'){
value = JSON.stringify(resourceData.value);
}
else if(field.atom.dataType === 'text' || field.atom.dataType === 'integer' || field.atom.dataType === 'float') {
if(!resourceData.value || resourceData.value === null || (typeof(resourceData.value) === 'object' && Object.keys(resourceData.value) <= 0)) {
value = '-';
} else if(field.atom.dataType === 'integer' || field.atom.dataType === 'float'){
value = utils.number.format(resourceData.value, fieldConfig.currencyFormat || fieldConfig.format || {}, field.atom.dataType).formatted
} else {
value = resourceData.value;
}
}
} else if(field.atom.dataType === 'custom'){
if((field.config || {}).tagBubbleList && resourceData){
var categories = (((resourceData || {}).children || {}).cms_entities_categories || {}).data || []
var bubbles = [], showIDs, categoryData, tag, c, tagKey, categoryEntityAttributes;
if(categories.length > 0){
showIDs = false;
if(storage.user){
showIDs = storage.user.hasRoleOption('showIDs', 'art_crm');
}
for(c in categories){
categoryEntityAttributes = categories[c].attributes || {}
categoryData = ((categories[c].children || {}).cms_categoriesData || {}).data || {};
tag = (((categoryData.attributes || {}).trls || {})[langCode] || {}).name || 'UNKNOWN_TAG'
tagKey = ''
if(categoryEntityAttributes.categoryID && categoryEntityAttributes.categoryDataID){
tagKey = `${categoryEntityAttributes.categoryID}_${categoryEntityAttributes.categoryDataID}`
}
if(showIDs){
tag = '[' + (categoryData.attributes || {})[categoryData.primaryKey || 'categoryDataID'] + '] ' + tag
}
bubbles.push('<div class="bubble" data-tag-key="' + tagKey + '">' + tag + '</div>');
}
value = '<div class="bubbles">' + (bubbles.join('') || '') + '</div>';
} else {
value = ''
}
} else if (fieldConfig.fieldPath){
fieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\//, '').replace(/\/$/, '');
} else {
value = '-';
}
} else {
value = '-';
}
}
var colClass = (field.config || {}).colClass;
var isEllipsis = colClass === 'ellipsis'
var additionalClasses = [];
if(fieldConfig.minWidth){
additionalStyles.push('min-width: ' + fieldConfig.minWidth);
}
if(fieldConfig.width){
additionalStyles.push('width: ' + fieldConfig.width);
}
if(fieldConfig.maxWidth){
additionalStyles.push('max-width: ' + fieldConfig.maxWidth);
}
if(additionalStyles.length > 0){
additionalStyle = ' style="' + additionalStyles.join(';') + '"';
}
if(field.fieldCode) additionalClasses.push('fieldOf_' + field.fieldCode);
if(colClass) additionalClasses.push(colClass);
var colSpan = 1;
var rowSpan = 1;
if(fieldConfig.colSpan) colSpan = fieldConfig.colSpan;
if(fieldConfig.rowSpan) rowSpan = fieldConfig.rowSpan;
if(fieldConfig.textAlign === 'right')       additionalClasses.push('textAlignRight')
else if(fieldConfig.textAlign === 'center') additionalClasses.push('textAlignCenter')

    ; __line = 151
    ; __append("\n<td colspan=\"")
    ; __line = 152
    ; __append(escapeFn( colSpan ))
    ; __append("\" rowspan=\"")
    ; __append(escapeFn( rowSpan ))
    ; __append("\" data-model-field-index=\"")
    ; __append(escapeFn( formMapping.modelFieldIndex ))
    ; __append("\" class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\" title=\"")
    ; __append(escapeFn( (isEllipsis ? value : '') ))
    ; __append("\"")
    ; __append( additionalStyle )
    ; __append(">\n")
    ; __line = 153
    ; 
if (fieldPath) {

    ; __line = 155
    ; __append( include(fieldPath, { model: field, config: fieldConfig.componentConfig || {}, resourceData: resourceData }) )
    ; 
} else {

    ; __line = 157
    ; __append( translationKey ? __(translationKey) : value )
    ; 
}

    ; __line = 159
    ; __append("\n</td>")
    ; __line = 160
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/tableSimple/col.ejs

}